import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import ApplyPage from './pages/ApplyPage';
import ContactPage from './pages/ContactPage';
import LocationsIndex from './pages/locations/LocationsIndex';
import StateIndex from './pages/locations/StateIndex';
import DynamicLocationPage from './pages/locations/DynamicLocationPage';
import MiamiPage from './pages/locations/MiamiPage';
import FortLauderdalePage from './pages/locations/FortLauderdalePage';
import WestPalmBeachPage from './pages/locations/WestPalmBeachPage';
import BlogListPage from './pages/blog/BlogListPage';
import BlogPostPage from './pages/blog/BlogPostPage';
import FeaturesIndex from './pages/features/FeaturesIndex';
import FeaturePage from './pages/features/FeaturePage';
import IndustriesIndex from './pages/industries/IndustriesIndex';
import IndustryPage from './pages/industries/IndustryPage';
import IndustryLocationPage from './pages/industries/IndustryLocationPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/apply/:slug" element={<ApplyPage />} />

        {/* Features */}
        <Route path="/features" element={<FeaturesIndex />} />
        <Route path="/features/:slug" element={<FeaturePage />} />

        {/* Industries */}
        <Route path="/industries" element={<IndustriesIndex />} />
        <Route path="/industries/:slug" element={<IndustryPage />} />
        <Route path="/industries/:industrySlug/:state/:locationSlug" element={<IndustryLocationPage />} />

        {/* Blog */}
        <Route path="/blog" element={<BlogListPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />

        {/* Locations */}
        <Route path="/locations" element={<LocationsIndex />} />
        <Route path="/locations/miami" element={<MiamiPage />} />
        <Route path="/locations/fort-lauderdale" element={<FortLauderdalePage />} />
        <Route path="/locations/west-palm-beach" element={<WestPalmBeachPage />} />
        <Route path="/locations/:state" element={<StateIndex />} />
        <Route path="/locations/:state/:slug" element={<DynamicLocationPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
